<template>
    <div>
        <slot name="modal-trigger"></slot>
        <v-dialog
            width= 50%
            outline
            v-model="show"
        >

            <v-form ref="form">
                <v-card>
                    <v-card-title class="text-h5" primary-title>
                        Add New&nbsp;<slot name="label" />
                    </v-card-title>
                    <v-divider />
                    <v-card-text>
                        <v-flex>
                            <slot name="modal-body" />
                        </v-flex>
                    </v-card-text>
                    <v-divider />
                    <v-card-actions>
                        <v-btn
                            data-testid="create-cancel-disposition-btn"
                            class="create-cancel-disposition-btn"
                            color="error"
                            @click.stop="collapse"
                        >
                            Cancel
                        </v-btn>
                        <v-spacer />
                        <slot name="create-button" @click.stop="collapse" />
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>

    </div>
</template>

<script>

export default {
  props: {
    value: {
      type: Boolean
    },
    submitted: {
      type: Boolean
    }
  },

  methods: {
    collapse() {
      this.show = false;
      this.$emit("collapse");
      this.resetValidation();
    },

    resetValidation() {
      if (this.$refs && this.$refs.form) {
        this.$refs.form.reset();
      }
    }
  },

  computed: {
    show: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit("input", newVal);
      }
    }
  },

  watch: {
    submitted() {
      this.resetValidation();
    }
  }
};
</script>
